import classNames from 'clsx';
import React from 'react';
import type { UseTableInstanceProps } from 'react-table';

import ToggleArrow from '@swf/core/assets/icons/arrow.svg';
import type { TableColumnInstance, Tournament } from '@swf/poker';

import styles from './TableHead.scss';

type Props = Pick<UseTableInstanceProps<Tournament>, 'headerGroups'> & {
  handleColumnClick: (column: TableColumnInstance) => void;
};

// TODO: Delete When we move Table Head in SWF-POKER
const TableHead: React.FC<Props> = ({ headerGroups, handleColumnClick }) => (
  <div className={styles.container}>
    {headerGroups.map((headerGroup) => {
      const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
      const onColumnClicked = (column: TableColumnInstance) => handleColumnClick(column);

      return (
        <div className={styles.row} key={key} {...headerGroupProps}>
          {headerGroup.headers.map((column: TableColumnInstance, columnIdx, columns) => {
            const { key, ...headerProps } = column.getHeaderProps(column.getSortByToggleProps());
            const tableColumn = column;
            return (
              <React.Fragment key={key}>
                <div
                  key={key}
                  {...headerProps}
                  className={classNames({ [styles.sortedHead]: tableColumn.isSorted }, styles.head)}
                  style={{
                    width: tableColumn.width,
                    textAlign: tableColumn.align
                  }}
                  data-testid="table-head-cell"
                  data-column-name={tableColumn.id}
                  onMouseDown={(e) => {
                    if ((e.target as HTMLElement).classList.contains(styles.resizer)) {
                      return;
                    }

                    onColumnClicked(tableColumn);
                  }}
                >
                  {tableColumn.render('Header')}
                  {tableColumn.isSorted && (
                    <ToggleArrow
                      className={classNames(styles.arrow, {
                        [styles.upwardsArrow]: tableColumn.isSortedDesc
                      })}
                    />
                  )}
                </div>
                {tableColumn.canResize && columnIdx !== columns.length - 1 && (
                  <div
                    {...tableColumn?.getResizerProps()}
                    className={styles.resizer}
                    data-testid="resizer"
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      );
    })}
  </div>
);

export default TableHead;
